function makeColorScheme(scheme, colors) {
    if (scheme == "light" || scheme == "dark") {
        return {
            scheme,
            colors: colors,
        };
    }
    else {
        return Object.assign(Object.assign({}, scheme), { colors: Object.assign(Object.assign({}, scheme.colors), colors) });
    }
}
export default makeColorScheme;
//# sourceMappingURL=make-color-scheme.js.map